import React from 'react'

const ResumeAnalyzer = () => {
  return (
    <div>ResumeAnalyzer</div>
  )
}

export default ResumeAnalyzer